import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import AppList from '../components/AppList';
import SupportForm from '../components/SupportForm';
import { DEFAULT_APP_ID, resolveAppId } from '../data/apps';
import './SupportPage.css';

function SupportPage() {
  const { t } = useLanguage();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedAppId = resolveAppId(searchParams.get('app'));

  useEffect(() => {
    document.title = t('support.meta.title');
  }, [t]);

  useEffect(() => {
    if (!searchParams.get('app')) {
      setSearchParams({ app: DEFAULT_APP_ID }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleSelectApp = (appId) => {
    setSearchParams({ app: appId });
    document.getElementById('support-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="support-page">
      <header className="support-hero">
        <Link to="/" className="support-back">
          ← {t('support.back')}
        </Link>
        <h1>{t('support.title')}</h1>
        <p>{t('support.subtitle')}</p>
      </header>
      <AppList selectedAppId={selectedAppId} onSelectApp={handleSelectApp} />
      <SupportForm key={selectedAppId} selectedAppId={selectedAppId} />
    </div>
  );
}

export default SupportPage;
